import ActionType from "../../types/ActionType"
import { SurveyAttributes, SurveyQuestionType, SurveyType } from "../../types/SurveyType"
import SurveysActions from "../actions/surveys"

export interface SurveysStore {
  surveys: SurveyType[]
  survey: SurveyType | null
  surveyAttributes: SurveyAttributes | null
  errorMessage: string
  loadingSurveys: boolean
  loadingSurvey: boolean
  surveysQuestions: SurveyQuestionType[]
  surveyQuestion: SurveyQuestionType | null
  loadingSurveysQuestions: boolean
  loadingSurveyQuestion: boolean
}

const INITIAL_STATE: SurveysStore = {
  surveys: [],
  survey: null,
  surveyAttributes: null,
  surveysQuestions: [],
  surveyQuestion: null,
  errorMessage: "",
  loadingSurveys: false,
  loadingSurvey: false,
  loadingSurveysQuestions: false,
  loadingSurveyQuestion: false,
}

export default (state = INITIAL_STATE, action: ActionType) => {
  switch (action.type) {
    case SurveysActions.FETCH_SURVEYS_TRIGGER: {
      return {
        ...state,
        loadingSurveys: true,
      }
    }

    case SurveysActions.FETCH_SURVEYS_SUCCESS: {
      return {
        ...state,
        surveys: action.payload,
        loadingSurveys: false,
      }
    }

    case SurveysActions.FETCH_SURVEYS_ERROR: {
      return {
        ...state,
        errorMessage: action.payload,
        loadingSurveys: false,
      }
    }

    case SurveysActions.FETCH_SURVEY_BY_ID_TRIGGER: {
      return {
        ...state,
        loadingSurvey: true,
      }
    }

    case SurveysActions.FETCH_SURVEY_BY_ID_SUCCESS: {
      return {
        ...state,
        survey: action.payload,
        loadingSurvey: false,
      }
    }

    case SurveysActions.FETCH_SURVEY_BY_ID_ERROR: {
      return {
        ...state,
        errorMessage: action.payload,
        loadingSurvey: false,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_TRIGGER: {
      return {
        ...state,
        loadingSurveysQuestions: true,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_SUCCESS: {
      return {
        ...state,
        surveysQuestions: action.payload.rows,
        surveyAttributes: action.payload.surveyAttributes ?? null,
        loadingSurveysQuestions: false,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_ERROR: {
      return {
        ...state,
        errorMessage: action.payload,
        loadingSurveysQuestions: false,
      }
    }

    case SurveysActions.FETCH_SURVEY_QUESTION_BY_ID_TRIGGER: {
      return {
        ...state,
        loadingSurveyQuestion: true,
      }
    }

    case SurveysActions.FETCH_SURVEY_QUESTION_BY_ID_SUCCESS: {
      return {
        ...state,
        surveyQuestion: action.payload,
        loadingSurveyQuestion: false,
      }
    }

    case SurveysActions.FETCH_SURVEY_QUESTION_BY_ID_ERROR: {
      return {
        ...state,
        errorMessage: action.payload,
        loadingSurveyQuestion: false,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_BY_SURVEY_TYPE_TRIGGER: {
      return {
        ...state,
        loadingSurveysQuestions: true,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_BY_SURVEY_TYPE_SUCCESS: {
      return {
        ...state,
        surveysQuestions: action.payload.rows,
        surveyAttributes: action.payload.surveyAttributes ?? null,
        loadingSurveysQuestions: false,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_BY_SURVEY_TYPE_ERROR: {
      return {
        ...state,
        errorMessage: action.payload,
        loadingSurveysQuestions: false,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_BY_SURVEY_ID_TRIGGER: {
      return {
        ...state,
        loadingSurveysQuestions: true,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_BY_SURVEY_ID_SUCCESS: {
      return {
        ...state,
        surveysQuestions: action.payload.rows,
        surveyAttributes: action.payload.surveyAttributes ?? null,
        loadingSurveysQuestions: false,
      }
    }

    case SurveysActions.FETCH_SURVEYS_QUESTIONS_BY_SURVEY_ID_ERROR: {
      return {
        ...state,
        errorMessage: action.payload,
        loadingSurveysQuestions: false,
      }
    }

    default: {
      return state
    }
  }
}
